// AppTopNav.js
import React from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import {AppBar, Toolbar, Typography, IconButton, Menu, MenuItem, Button} from '@material-ui/core';
import { Menu as MenuIcon, AccountCircle, Settings } from '@material-ui/icons';
import { Link, useNavigate } from 'react-router-dom';

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      flexGrow: 1
    },
	appBar : {
		background : '#009955',
		zIndex: theme.zIndex.drawer + 1
	},
    menuButton: {
      marginRight: theme.spacing(2),
	  [theme.breakpoints.up('md')]: {
		  display: 'none'
	  }
    },
    title: {
      flexGrow: 1,
    },
  }),
);

export default function AppTopNav(props) {
  const classes = useStyles();
	const {handleDrawerToggle, user, organization, login, handleSend, setUser, altUser, setAltUser} = props;
	const navigate = useNavigate();
	const [anchorElUser, setAnchorElUser] = React.useState(null);
	const [anchorElSettings, setAnchorElSettings] = React.useState(null);
	const [admin, setAdmin] = React.useState(false);
	const openUser = Boolean(anchorElUser);
	const openSettings = Boolean(anchorElSettings);
	const handleUserMenu = (event) => {
		setAnchorElUser(event.currentTarget);
	};
	const handleSettingsMenu = (event) => {
		setAnchorElSettings(event.currentTarget);
	};
	const handleClose = (event) => {
		setAnchorElUser(null);
		setAnchorElSettings(null);
	};
	const clickLogin = (e) => {login(true);};
	const menuOrigins = {
		vertical: 'top',
		horizontal: 'right'
	};
	React.useEffect(() => {
		if(user){
			if(user.usergroup){
				setAdmin(user.usergroup === 1 || user.edit_function === 1)
			}
		}
	}, [user])
	
	const handleLogout = () => {
	
		handleSend({
		  	vso: 'logout'
	  	}, (data) => {
			login(true);
			//setUser({});
			//navigate('/');
			//handleClose();
	  	});
		  setUser({});
		  navigate('/');
		  handleClose();
	};

	const endPreview = () => {
		if(!altUser) return false;
		//resume user
		setUser(altUser);
		//remove alternate user
		setAltUser({});
		handleSend({
			vso: 'user',
			user : user,
			subaction : 'unpreview'
		});
		handleClose();
	}
	const renderSettingMenu = () => {
		if(!user || !user.usergroup) return '';
		if(admin){
			return (
				<IconButton 
	  				aria-label="Settings" 
	  				aria-controls="settings-menu"
	  				aria-haspopup="true"
	  				onClick={handleSettingsMenu}
	  				color="inherit">
	  			<Settings />
				</IconButton>
			);
		}
		return '';
	}

	const renderUserMenu = () => {
		if(!user || !user.usergroup) return (<Button color='inherit' onClick={clickLogin}>Log in</Button>);

		let items = [
			(<MenuItem component={Link} to={"/organization/"+organization.id} key={1} onClick={handleClose}>Organization</MenuItem>),
			(<MenuItem onClick={handleLogout} key={2}>Log Out</MenuItem>)
		];
		if(altUser && altUser.id) {
			items.unshift(<MenuItem onClick={endPreview} key={0}>Stop Preview</MenuItem>);
		}
		return [(<IconButton key={1}
	  			aria-label="Current User" 
	  			color="inherit"
	  			aria-controls="user-menu"
	  			aria-haspopup="true"
	  			onClick={handleUserMenu}
	  		>
	  		<AccountCircle />
	  	  </IconButton>), (
			<Menu 
	  			id="user-menu"
	  			anchorEl={anchorElUser}
	  			anchorOrigin={menuOrigins}
	  			keepMounted
	  			transformOrigin={menuOrigins}
	  			open={openUser}
	  			onClose={handleClose}
				key={2}
	  		>
	  		{items}
	  		</Menu>
		  )];
	}
	/* Not supported yet
	<MenuItem onClick={handleClose}>Permissions</MenuItem>
	<MenuItem onClick={handleClose}>Sharing</MenuItem>
	//profile menu (avatar)
	<MenuItem onClick={handleClose}>My Profile</MenuItem>
	*/

  return (
    <div className={classes.root}>
      <AppBar className={classes.appBar} position="fixed">
        <Toolbar>           
	  		<IconButton
            	color="inherit"
            	aria-label="menu"
            	edge="start"
            	onClick={handleDrawerToggle}
            	className={classes.menuButton}
          	>
	  			<MenuIcon />
          	</IconButton>
          <Typography variant="h6" className={classes.title}>
            VSpeed&trade; Online
          </Typography>
	  	  <Typography variant="subtitle1" className={classes.title}>
	        {organization.name}
	      </Typography>
	  	  {renderSettingMenu()}
	  	  
	  		{renderUserMenu()}
	  		<Menu 
	  			id="settings-menu"
	  			anchorEl={anchorElSettings}
	  			anchorOrigin={menuOrigins}
	  			keepMounted
	  			transformOrigin={menuOrigins}
	  			open={openSettings}
	  			onClose={handleClose}
	  		>
	  			<MenuItem component={Link} to={"/options"} onClick={handleClose}>Sign Options</MenuItem>
	  			<MenuItem component={Link} to={"/types"} onClick={handleClose}>Sign Types</MenuItem>
	  			<MenuItem component={Link} to={"/ph5_settings"} onClick={handleClose}>Ph5 Settings</MenuItem>
	  		</Menu>
        </Toolbar>
      </AppBar>
    </div>
  );
}